<a
  [routerLink]="['/product-details', product.slug]"
  class="game-card"
  *ngIf="product"
>
  <div class="game-card__image-container">
    <img
      class="game-card__image"
      [src]="mainAsset.preview"
      [alt]="product.name"
    />
  </div>
  <div class="game-card__details">
    <div class="game-card__platforms">
      <span
        *ngFor="let platform of platforms"
        class="game-card__platforms__platform-icon"
        nz-icon
        [nzType]="platform.icon"
      >
      </span>
    </div>

    <div class="game-card__pricing">
      <div
        class="game-card__discount-badge"
        *ngIf="discountPercentage > 0"
      >
        -{{ discountPercentage }}%
      </div>
      <div class="game-card__price-info">
        <span
          *ngIf="discountPercentage > 0"
          class="game-card__original-price"
        >
          {{ product.variants[0].price | currency:'EUR':'symbol':'1.2-2' }}
        </span>
        <span class="game-card__current-price">
          {{ product.variants[0].price | currency:'EUR':'symbol':'1.2-2' }}
        </span>
      </div>
    </div>
  </div>
</a>

<div class="desktop-skeleton" *ngIf="!product"></div>
